import React from 'react';

// Styles
import { Tagline, ZolaBabyLogoContainer, ZolaLinkContainer } from './ZolaBabyLogo.styles';
import COLORS from '../../styles/emotion/colorsBaby';

export interface LinkPropsType extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  'data-testid'?: string;
}

type LogoType = 'logomark';

export type ZolaBabyLogoProps = {
  id?: string;
  className?: string;
  color?: string;
  containerElement?: 'div' | 'a';
  handleClick?: () => void;
  linkProps?: LinkPropsType;
  showTagline?: boolean;
  type?: LogoType;
};

const defaultColor = COLORS.PD_ULTRAMARINE_100;
const defaultContainerElement = 'div';
const defaultType: LogoType = 'logomark';
const taglineText = 'For all the days along the way';

const ZolaBabyLogo: React.FC<ZolaBabyLogoProps> = ({
  id,
  className,
  color = defaultColor,
  containerElement = defaultContainerElement,
  handleClick,
  linkProps,
  showTagline,
  type = defaultType,
}) => {
  const renderZolaBabyLogo = (): JSX.Element => {
    return (
      <svg data-name="Zola Baby Logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1923.12 329">
        <title>Zola Baby Logo</title>
        <path
          fill={color}
          d="m1716.25,238.1c1.77-1.6,6.76-6.38,12.61-12.44,27.12-27.93,73.32-82.25,78.16-132.25,2.17-22.35-4.6-44.29-19.06-61.77-14.93-18.01-36.15-29.12-59.74-31.28-32.36-2.95-63.52,11.79-81.31,38.46-1.31,1.97-2.57,4.05-3.73,6.17l-1.17,2.11-2.23-.9c-2.27-.91-4.56-1.72-6.8-2.41-8.34-2.55-16.89-3.8-25.38-3.8-22.72,0-45.03,8.91-61.91,25.48-16.91,16.61-26.31,38.64-26.46,62.03-.13,22.68,8.52,43.94,24.34,59.88,35.38,35.65,105.54,48.46,144.21,52.93,8.42.99,15.27,1.53,17.6,1.64h.12c.12.02,2.72.28,5.54-.55l.55-.2c2.69-1.15,4.54-3,4.56-3.02l.1-.1Zm-7.29-31.75c-2.22,2.29-4.43,4.52-6.56,6.62l-.9.89-1.27-.12c-2.8-.25-5.92-.58-9.27-.97-28.24-3.27-97.21-14.18-127.71-44.91-10.6-10.68-16.37-24.96-16.27-40.18.1-15.96,6.54-31.01,18.14-42.4,6.44-6.32,13.97-11.05,22.38-14.05,12.19-4.35,25.11-4.66,37.35-.9,6.6,2.02,14.33,5.25,26.04,15.12,2.09,1.87,3.99,3.57,5.45,4.87.7.62,1.81.23,1.96-.7.31-1.94.71-4.45,1.12-7.14,2.83-15.13,6.77-22.52,10.6-28.27,7.1-10.66,17.3-18.59,29.49-22.94,8.41-3,17.23-4.1,26.22-3.28,16.18,1.47,30.7,9.05,40.87,21.35,9.71,11.73,14.27,26.43,12.83,41.41h0c-4.17,43.1-50.67,95.2-70.46,115.6Z"
        />
        <path
          fill={color}
          d="m1923.06,156.23h0c-.73-16.84-8.07-32.45-20.67-43.94-17.28-15.76-41.57-20.84-63.4-13.27-.86.3-1.73.63-2.58.97-.51-.78-1.04-1.55-1.57-2.29-3.63-5.03-7.98-9.48-12.92-13.23-13.3-10.08-29.85-14.46-46.58-12.31-16.92,2.17-31.89,10.73-42.16,24.1-9.97,12.99-14.27,29.01-12.11,45.09,4.63,34.63,37.55,70.64,56.75,89.02,4.18,4.01,7.66,7.12,8.84,8.1.47.43,2.2,1.92,4.71,2.87l.83.26c1.15.29,2.37.43,3.63.43.81,0,1.41-.06,1.66-.09,1.67-.14,6.39-.7,11.99-1.56,26.28-4.02,73.92-14.59,97.6-40.27,11-11.93,16.68-27.51,15.99-43.87Zm-36.38,25.07c-6.2,6.72-26.54,23.25-81.43,31.66-1.61.25-3.2.48-4.75.68-1.11-1.03-2.29-2.14-3.51-3.3-40.08-38.39-47.24-63.61-48.45-72.67-1.16-8.73,1.19-17.44,6.63-24.52,5.73-7.47,14.14-12.25,23.67-13.47,1.58-.2,3.17-.31,4.73-.31,3.68,0,7.34.56,10.86,1.68,7.29,2.3,13.47,6.76,17.88,12.88,2.41,3.33,4.92,7.67,6.98,16.79.39,2,1.74,8.76,2.43,12.24.18.92,1.3,1.27,1.98.62,2.61-2.49,7.72-7.35,8.98-8.57,6.97-6.32,11.53-8.44,15.42-9.79,7.13-2.48,14.75-2.57,22.04-.27,5.04,1.59,9.6,4.23,13.55,7.83,7.1,6.48,11.23,15.22,11.64,24.63.38,8.92-2.69,17.4-8.66,23.88Z"
        />
        <path
          fill={color}
          d="m1455.93,77.33h-19.32c-1.89,0-3.54,1.31-3.96,3.16-16.87,75.09-53.88,134.05-53.88,134.05l-55.83-134.72c-.63-1.51-2.11-2.49-3.75-2.49h-21.43c-2.91,0-4.88,2.98-3.74,5.66l67.74,158.75-.13.2c-15.44,22.99-32.84,44.95-52.05,65.71-1.48,1.6-1.45,4.07.07,5.62l12.74,14.51c1.62,1.65,4.3,1.62,5.87-.07,31.34-33.75,58.13-70.56,79.82-109.73,24.06-43.45,41.47-89.07,51.81-135.69.56-2.54-1.37-4.95-3.97-4.95Z"
        />
        <path
          fill={color}
          d="m41.24,216.21l100.18-111.98c.67-.75,1.04-1.71,1.04-2.71v-20.13c0-2.24-1.82-4.06-4.06-4.06H4.06c-2.24,0-4.06,1.82-4.06,4.06v17.62c0,2.24,1.82,4.06,4.06,4.06h103.25L6.51,215.05c-.67.75-1.04,1.72-1.04,2.72v20.12c0,2.24,1.82,4.06,4.06,4.06h134.32c2.24,0,4.06-1.82,4.06-4.06v-17.62c0-2.24-1.82-4.06-4.06-4.06H41.24Z"
        />
        <path
          fill={color}
          d="m306.88,100.34c-15.95-16.18-37.2-25.19-59.85-25.35-.21,0-.43,0-.64,0-22.42,0-43.56,8.67-59.58,24.47-16.18,15.95-25.18,37.2-25.35,59.86-.17,22.65,8.53,44.04,24.47,60.22,15.95,16.18,37.2,25.18,59.86,25.35,22.55.39,44.04-8.53,60.22-24.47,16.18-15.95,25.18-37.2,25.35-59.85.17-22.65-8.52-44.04-24.47-60.23Zm-60.48,117.39c-.14,0-.28,0-.43,0-31.86-.24-57.59-26.35-57.36-58.21.24-31.86,26.42-57.53,58.21-57.36,31.86.23,57.59,26.34,57.36,58.2-.24,31.72-26.12,57.36-57.78,57.36Z"
        />
        <path
          fill={color}
          d="m883.25,158.88c-.17-22.63-9.17-43.87-25.35-59.8-16.03-15.78-35.84-24.45-58.26-24.45-.21,0-.43,0-.64,0-14.12,0-38.05,2.15-58.56,26.27V4.06C740.44,1.82,738.62,0,736.38,0h-18.96C715.17,0,713.35,1.82,713.35,4.06v233.83c0,2.24,1.82,4.06,4.06,4.06h18.96c2.24,0,4.06-1.82,4.06-4.06v-19.27c20.52,24.13,44.44,26.28,58.56,26.28h.64c22.42,0,42.23-8.67,58.26-24.45,16.18-15.93,25.18-37.17,25.35-59.8,0-.3-.01-.59-.02-.88,0-.29.02-.59.02-.88Zm-27.17,1.57c-.24,31.83-25.09,57.47-56.88,57.3-31.8-.23-58.82-26.23-58.68-57.98-.14-31.76,26.88-57.76,58.68-57.98,31.79-.17,56.64,25.47,56.88,57.3,0,.23-.01.46-.01.68,0,.23.01.46.01.68Z"
        />
        <path
          fill={color}
          d="m1281.59,158.88c-.17-22.63-9.17-43.87-25.35-59.8-16.03-15.78-35.84-24.45-58.26-24.45-.21,0-.43,0-.64,0-14.12,0-38.05,2.15-58.56,26.27V4.06C1138.78,1.82,1136.96,0,1134.71,0h-18.96C1113.51,0,1111.69,1.82,1111.69,4.06v233.83c0,2.24,1.82,4.06,4.06,4.06h18.96c2.24,0,4.06-1.82,4.06-4.06v-19.27c20.52,24.13,44.44,26.27,58.56,26.27.21,0,.43,0,.64,0,22.42,0,42.23-8.67,58.26-24.45,16.18-15.93,25.18-37.17,25.35-59.8,0-.3-.01-.59-.02-.88,0-.29.02-.59.02-.88Zm-27.17,1.57c-.24,31.83-25.09,57.47-56.88,57.3-31.8-.23-58.82-26.23-58.68-57.98-.14-31.76,26.88-57.76,58.68-57.98,31.79-.17,56.64,25.47,56.88,57.3,0,.23-.01.46-.01.68,0,.23.01.46.01.68Z"
        />
        <path
          fill={color}
          d="m1045.21,81.4v19.51c-20.52-24.13-44.44-26.27-58.56-26.27-.21,0-.43,0-.64,0-22.42,0-42.23,8.67-58.26,24.45-16.18,15.93-25.18,37.17-25.35,59.8,0,.3.01.59.02.88,0,.29-.02.59-.02.88.17,22.63,9.17,43.87,25.35,59.8,16.03,15.78,35.84,24.45,58.26,24.45.21,0,.43,0,.64,0,14.12,0,38.05-2.15,58.56-26.27v19.27c0,2.24,1.82,4.06,4.06,4.06h18.96c2.24,0,4.06-1.82,4.06-4.06V81.4c0-2.24-1.82-4.06-4.06-4.06h-18.96c-2.24,0-4.06,1.82-4.06,4.06Zm-58.76,136.35c-31.79.17-56.64-25.47-56.88-57.3,0-.23.01-.46.01-.68,0-.23-.01-.46-.01-.68.24-31.83,25.09-57.47,56.88-57.3,31.8.23,58.82,26.23,58.68,57.98.14,31.76-26.88,57.76-58.68,57.98Z"
        />
        <path
          fill={color}
          d="m386.44,241.96c2.24,0,4.06-1.82,4.06-4.06v-80.71h0v-81.06h0V4.06C390.5,1.82,388.68,0,386.44,0h-18.96C365.23,0,363.41,1.82,363.41,4.06v72.06h0v81.06h0v80.71c0,2.24,1.82,4.06,4.06,4.06h18.96Z"
        />
        <path
          fill={color}
          d="m565.38,81.4v19.51c-20.52-24.13-44.44-26.27-58.56-26.27-.21,0-.43,0-.64,0-22.42,0-42.23,8.67-58.26,24.45-16.18,15.93-25.18,37.17-25.35,59.8,0,.3.01.59.02.88,0,.29-.02.59-.02.88.17,22.63,9.17,43.87,25.35,59.8,16.03,15.78,35.84,24.45,58.26,24.45.21,0,.43,0,.64,0,14.12,0,38.05-2.15,58.56-26.27v19.27c0,2.24,1.82,4.06,4.06,4.06h18.96c2.24,0,4.06-1.82,4.06-4.06V81.4c0-2.24-1.82-4.06-4.06-4.06h-18.96c-2.24,0-4.06,1.82-4.06,4.06Zm-58.76,136.35c-31.79.17-56.64-25.47-56.88-57.3,0-.23.01-.46.01-.68,0-.23-.01-.46-.01-.68.24-31.83,25.09-57.47,56.88-57.3,31.8.23,58.82,26.23,58.68,57.98.14,31.76-26.88,57.76-58.68,57.98Z"
        />
      </svg>
    );
  };

  const renderContent = (): JSX.Element => {
    const renderers: Record<LogoType, () => JSX.Element> = {
      logomark: renderZolaBabyLogo,
    };

    const renderer = renderers[type];

    return (
      <React.Fragment>
        {renderer()}
        {showTagline && <Tagline>{taglineText}</Tagline>}
      </React.Fragment>
    );
  };

  if (containerElement === 'a') {
    return (
      <ZolaLinkContainer
        id={id}
        className={className}
        showTagline={showTagline}
        onClick={handleClick}
        type={type}
        {...linkProps}
      >
        {renderContent()}
      </ZolaLinkContainer>
    );
  }

  return (
    <ZolaBabyLogoContainer
      id={id}
      className={className}
      showTagline={showTagline}
      type={type}
      onClick={handleClick}
    >
      {renderContent()}
    </ZolaBabyLogoContainer>
  );
};

export default ZolaBabyLogo;
